import { Stack, Typography } from "@mui/material";
import React from "react";
import BalanceCheckerEditorHelpButton from "./BalanceCheckerEditorHelpButton";
import LanguageSelect from "../LanguageSelect";

function BalanceCheckerEditorHeader() {
  // Render
  return (
    <Stack
      direction="row"
      spacing={1}
      p={1}
      sx={{ display: "flex", alignItems: "center" }}
    >
      <Typography variant="h4" component="h1" sx={{ flexGrow: 1 }}>
        <img
          src="/logo192.png"
          width="50"
          height="50"
          style={{ verticalAlign: "middle", marginRight: "12px" }}
          alt="123TCS logo"
        />
        Balance Checker Editor
      </Typography>

      <BalanceCheckerEditorHelpButton />

      <LanguageSelect />
    </Stack>
  );
}

export default BalanceCheckerEditorHeader;
